'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../lib/utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Class for constructing a request object to use for communicating with the analytics API endpoint.
 *
 * @param {!Object} options Object with analytics request options
 *
 * @requires module:lib/utils
 *
 * @memberof module:analytics
 * @abstract
 */
var AnalyticsRequestBase = function () {
    function AnalyticsRequestBase() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$endPoint = _ref.endPoint,
            endPoint = _ref$endPoint === undefined ? 'analytics' : _ref$endPoint,
            _ref$format = _ref.format,
            format = _ref$format === undefined ? 'json' : _ref$format,
            path = _ref.path,
            program = _ref.program,
            _ref$dimensions = _ref.dimensions,
            dimensions = _ref$dimensions === undefined ? {} : _ref$dimensions,
            _ref$filters = _ref.filters,
            filters = _ref$filters === undefined ? {} : _ref$filters,
            _ref$parameters = _ref.parameters,
            parameters = _ref$parameters === undefined ? {} : _ref$parameters;

        _classCallCheck(this, AnalyticsRequestBase);

        this.endPoint = endPoint;
        this.format = format.toLowerCase();
        this.path = path;
        this.program = program;

        this.dimensions = _extends({}, dimensions);
        this.filters = _extends({}, filters);
        this.parameters = _extends({}, parameters);
    }

    /**
     * @private
     * @description
     * Builds the URL to pass to the Api object.
     * The URL includes the dimension(s) parameters.
     * Used internally.
     *
     * @returns {String} URL URL for the request with dimensions included
     */


    _createClass(AnalyticsRequestBase, [{
        key: 'buildUrl',
        value: function buildUrl() {
            // at least 1 dimension is required
            var encodedDimensions = Object.entries(this.dimensions).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    dimension = _ref3[0],
                    values = _ref3[1];

                if (Array.isArray(values) && values.length) {
                    return dimension + ':' + values.map(_utils.customEncodeURIComponent).join(';');
                }

                return dimension;
            });

            var endPoint = [this.endPoint, this.path, this.program].filter(function (e) {
                return !!e;
            }).join('/');

            return endPoint + '.' + this.format + '?dimension=' + encodedDimensions.join('&dimension=');
        }

        /**
         * @private
         * @description
         * Builds the query object passed to the API instance.
         * The object includes all the parameters added via with*() methods
         * and the filters added via addDataFilter(), addPeriodFilter(), addOrgUnitFilter(), addFilter().
         * The filters are handled by the API instance when building the final URL.
         * Used internally.
         *
         * @returns {Object} Query parameters
         */

    }, {
        key: 'buildQuery',
        value: function buildQuery() {
            var encodedFilters = Object.entries(this.filters).map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    dimension = _ref5[0],
                    values = _ref5[1];

                return dimension + ':' + values.map(_utils.customEncodeURIComponent).join(';');
            });

            if (encodedFilters.length) {
                this.parameters.filter = encodedFilters;
            }

            return this.parameters;
        }
    }]);

    return AnalyticsRequestBase;
}();

exports.default = AnalyticsRequestBase;
//# sourceMappingURL=AnalyticsRequestBase.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/analytics/AnalyticsRequestBase.js
// module id = 570
// module chunks = 13